import { combineReducers } from "redux";
import { IListDto } from "../../../interface/dto/list.dto";
import { IIGSEState } from "../../../shared/igse-redux/igse-state";
import { announcementsReducer } from "./announcements";
import { historyReducer } from "./history";

export const homeReducer = combineReducers({
    announcements: announcementsReducer,
    history: historyReducer,
});

export interface IHomeState {
    announcements: IIGSEState<Array<string>>;
    history: IIGSEState<Array<IListDto>>;
}
